import ThemeProvider from '@zegal/components/src/base/common/wrapThemeProvider';

export const WrapThemeProvider = ThemeProvider;
